import LogViewerExample from "./Example.Accordion";

export default [
    {
        code: require("!raw-loader!./Example.Accordion.tsx"),
        component: LogViewerExample,
        stretchContainer: true,
        title: "Basic accordion"
    }
];
